import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'shared/components/alerts';
import { useUpdateFlexWorker } from 'hq/hooks/queryHooks/flexWorkers/useUpdateFlexWorker';
import { useZodSchema } from 'shared/hooks';
import { createFlexWorkerContractSchema } from './schema';
import { FlexWorkerContractForm, FlexWorkerContractProps } from './flex-worker-contract-body.types';
import { resolveContractMinutes } from '../../../../../../../shared/utils/resolve-contract-minutes';

export const useFlexWorkerContractForm = ({ data, onClose }: FlexWorkerContractProps) => {
  const { t } = useTranslation('web-common');
  const schema = useZodSchema(createFlexWorkerContractSchema, 'web-common');
  const { alertSuccess, alertError } = useAlert();
  const updateFlexWorker = useUpdateFlexWorker(data.id);
  const form = useForm<FlexWorkerContractForm>({
    resolver: zodResolver(schema),
    defaultValues: {
      contractStartDate: data.contractStartDate,
      contractEndDate: data.contractEndDate,
      contractHours: data.contractMinutes ? data.contractMinutes / 60 : 0,
    },
  });

  const handleSubmit = form.handleSubmit((fromData) => {
    const payload = {
      ...fromData,
      contractMinutes: resolveContractMinutes(fromData.contractHours ?? undefined),
    };
    updateFlexWorker.mutate(
      {
        contractStartDate: payload.contractStartDate,
        contractEndDate: payload.contractEndDate,
        contractMinutes: payload.contractMinutes,
      },
      {
        onSuccess: () => {
          onClose();
          alertSuccess(t('flex-worker-detail.contract.form.success-message'));
        },
        onError: (e) => {
          alertError(e);
        },
      }
    );
  });

  return { form, handleSubmit };
};
